<template>
  <div class="sequence-list">
    <!--
    <router-link to='/sequence/1/preview'>preview</router-link> |
    <router-link to='/sequence/'>back</router-link>
    -->
    <div class="sequence-list-header" style="border-top: none">
      <h4>My routines</h4>
    </div>

    <!-- TODO: Show where is sequecne is used -->

    <div v-if="sequences_sorted.$readySome">
      <router-link
        v-for="sequence in sequences_sorted.items"
        :key="sequence.$key"
        :to="'/sequence/'+sequence.$id+'/editor'">
        <div :class="{
          'menu-item': true,
          'route-is-active': sequence.$id === $route.params.sequenceId}">

          <span class="menu-item__text">
            <!-- <i class="el-icon-caret-right"></i>  -->
            <i class="el-icon-document"></i>
            {{sequence.name}}
          </span>

          <ellipsis-button
            style="float: right; width: 10px; margin-right: 25px;"
            placement="bottom"
            heading="Sequence actions"
            :show-options="['rename', 'slot', 'archive', 'delete']"
            @rename="onEditName( sequence.$id, sequence.name )"
            @archive="onDeleteSequence( sequence.$id, true )"
            @delete="onDeleteSequence( sequence.$id )">

            <el-button
              @click="onShareRoutine( sequence.$id )"
              size="mini"
              class="ml-0 btn-block mt-2">
              <font-awesome-icon icon="share" />
              Share routine
            </el-button>

            <el-button
              v-for="(isEditor, viewerId) in sequence.viewers"
              :key="viewerId"
              @click="onRevokeRoutine( sequence.$id, viewerId )"
              type="info"
              size="mini"
              class="ml-0 btn-block mt-2">
              <font-awesome-icon icon="trash" />
              <!-- TODO: This is dangerous when clicking twice -->
              Revoke {{isEditor ? 'editor' : 'viewer'}}<br />
              <template v-if="get_contact_by_id(viewerId)">
                <!-- {{ get_contact_by_id(viewerId).email }} -->
                <strong>{{ get_contact_by_id(viewerId).displayName}}</strong>
                <img
                  class="user-mini-image mx-1"
                  style="border-radius: 100%"
                  width="16" height="16"
                  :src="get_contact_by_id(viewerId).profilePic|defaultUserPic"
                />
              </template>
            </el-button>

          </ellipsis-button>

          <!--
          <el-button
            style="float:right;"
            type="danger"
            size="mini"
            icon="el-icon-delete"
            title="Delete sequence"
            circle
            @click="onDeleteSequence( sequence.$id )"></el-button>

          <el-button
            style="float:right; margin-right:3px"
            type="info"
            size="mini"
            icon="el-icon-edit"
            title="Change sequence name"
            circle
            @click="onEditName( sequence.$id, sequence.name )"></el-button>
          -->

          <!-- <pre class="mini-pre">ID: {{sequence.$id}}, sortidx: {{sequence.sortidx}}</pre> -->
        </div>
      </router-link>
    </div>

    <el-button @click="onCreateSequence()" size="mini" type="secondary" class="mx-auto mt-4 d-block">
      <font-awesome-icon icon="plus" class="mr-1" />
      Create new routine
    </el-button>
    <!-- <pre class="mini-pre">{{sequences_sorted}}</pre> -->

    <div class="sequence-list-header mt-4">
      <h4>Shared routines</h4>
    </div>

    <router-link
      v-for="shared_sequence in shared_sequences_sorted.items"
      :key="shared_sequence.$key"
      :to="'/sequence/'+shared_sequence.$id+'/editor'">
      <div :class="{
        'menu-item': true,
        'route-is-active': shared_sequence.$id === $route.params.sequenceId}"
        style="height: unset; line-height: unset;">

        <div class="menu-item__text">
          <i class="el-icon-document"></i>
          {{shared_sequence.cachedName}}
        </div>
        <div style="font-size: 8pt; clear: both;" class="my-1">
          Shared by:
          <!-- TODO! -->
          <router-link
            :to="'/draft/user/'+shared_sequence.senderId">
            <img :src="shared_sequence.cachedProfilePic" width="16" style="border-radius: 100%; margin: 0 3px" />
            {{shared_sequence.cachedSenderName}}
          </router-link>
          <!-- TODO: Allow to remove -->
          <!-- TODO: Show placeholder when deleted -->
        </div>
      </div>
    </router-link>
    <p v-if="shared_sequences_sorted.items.length === 0" class="m-2">
      No routines found
    </p>

    <!--
    <hr class="my-4">
    <h4>Organization routines</h4>
    <hr class="my-4">
    <p class="m-2">
      No routines found
    </p>
    -->

  </div>
</template>

<script>
import UserPromptMixin from '@/components/Mixins/Prompts/UserPrompt'

// this.$models.sequence
// this.$models.sequenceAction
// this.$models.sequenceItem

export default {
  mixins: [ UserPromptMixin ],
  data: () => ({
  }),
  watch: {
    sequences_sorted( sequence_list ) {
      let contacts = []
      sequence_list.items.forEach(sequence => {
        contacts.push( ...Object.keys( sequence.viewers || {} ) )
      })
      console.log("sequences_sorted:contacts", contacts);
      contacts.forEach(memberUserId => {
        this.$api.contact_add_if_not_cached( memberUserId );
      })
    }
  },
  computed: {

    sequences_sorted() {
      // console.log("[TEMPLATE] sequences_sorted");
      // TODO:
      // const my_sequence_ids =  [...]
      // return this.$models.sequence.subscribeList([ my_sequence_ids ]);
      // return this.$models.sequence.subscribeList().asArraySorted();
      // userSequenceSettings
      let userId = this.$models.user.defaultUserId;
      return this.$models.sequence.subscribeQuery({ key: 'owner', value: userId }).asArraySorted();
    },

    shared_sequences_sorted() {
      return this.$models.userSequenceSettings.subscribeList().asArraySorted();
    },

    sequences_sorted_draggable: {
      get() {
        return this.sequences_sorted;
      },
      set (items) {
        console.log('sequences_sorted() setter', items)
        // let list = this.sequences_sorted.itemsAsArray().map(item => item.$id);
        // let idx = list.findIndex( item => item === sequence_id );
        // if ( !( idx === 0 && direction === -1 ) ) {
        //   list.move( idx, idx + direction )
        //   this.$models.sequence.reorder( list )
        // }
      }
    },
  },
  methods: {
    get_contact_by_id(userId) {
      return this.$models.userContact.get_contact_by_id( userId )
    },

    onCreateSequence() {
      let sortidx = 1

      let items = this.sequences_sorted.itemsAsArray();
      if (items && items.length > 0) {
        sortidx = items[ items.length - 1 ].sortidx + 100
      }

      let user_id = this.$models.user.defaultUserId;

      this.$prompt('Please enter sequence name', 'New Sequence', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        closeOnClickModal: false,
      }).then(({ value }) => {

        // TODO: Does not work in production
        // let form = this.$db.new_from_template( this.$models.sequence, { name: value, user_id } )
        let form = this.$models.sequence.new_from_template({ name: value, user_id })
        // form.setValidationBehaviour('ELEMENT_VALIDATION')
        form.sortidx = sortidx || 1;
        form.write().then(id => {
          this.$router.push( '/sequence/' + id + '/editor' );
        })
        // this.$models.sequence.add({ name: value, user_id, data: { sortidx } })

        // TODO: automatically opeen
      }).catch();
    },

    onEditName( sequenceId, currentName ) {
      this.$prompt('Please enter sequence name', 'Edit Sequence', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        closeOnClickModal: false,
        inputValue: currentName
      }).then(({ value }) => {
        this.onSetSequenceName( sequenceId, value )
      }).catch();
    },

    onDeleteSequence( sequenceId, soft_delete ) {
      if ( soft_delete) {
        // TODO: Soft delete!
        throw new Error('NOT_IMPLEMENTED')
      }
      this.$models.sequence.remove( sequenceId )
    },

    onSetSequenceName( sequence_id, name ) {
      console.log("onSetSequenceName", sequence_id, name);
      this.$models.sequence.update( sequence_id, { name: name })
    },

    onShareRoutine( sequenceId ) {
      // this.$invite_prompt?
      this.$user_prompt().then(({ selection, done }) => {
        this.$api.sequence_share_with_friend({
          sequence_id: sequenceId,
          user_id:     selection.id,
        }).then(done)
      })
    },

    onRevokeRoutine( sequenceId, userId ) {
      this.$api.sequence_revoke({
        sequence_id: sequenceId,
        user_id:     userId,
      })
    }
  },
  components: {
  }
};
</script>

<style>
.sequence-list .menu-item {
  height: 34px;
  line-height: 30px;
  margin: 5px 0;
  padding: 2px 8px;
  /* border-bottom: 1px solid gray; */
  color: black;
}
.sequence-list a:hover {
  text-decoration: none;
}
.sequence-list .menu-item:hover {
  background-color: #eee;
}
.sequence-list .menu-item.route-is-active {
  background-color: #ccc;
}
.sequence-list .menu-item .menu-item__text {
  font-weight: bold;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  float: left;
}
.sequence-list-header {
  height: 50px;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.sequence-list-header h4 {
  text-align: center;
  line-height: 50px;
  margin: 0;
  padding: 0;
}
</style>
